import DefaultValue from '@/defaultValue';
import Salarie from '@/generated/classes/Salarie';
import { typePicto } from '@/framework/base/helpers/Picto';
import { PictoTypes } from '@/generated/classes/Module';
import { storeSession } from '@/generated/stores';
import { getRequestConfig } from '@/framework/base/helpers/HttpHelper';

export default class SalarieExtend extends Salarie {
  constructor() {
    super();
    if (this.paysNationaliteId == 0) {
      const value = DefaultValue.defaultValueMap.get('pays');
      this.paysNationaliteId = value ? value : 0;
      this.paysNaissanceId = value ? value : 0;
    }
  }

  public static getPrenomNom(salarie: Salarie): string {
    return ((salarie.prenom ?? '') + ' ' + (salarie.nom ?? '')).trim();
  }

  public static idsByEtablissement(etablissementId: number): Promise<number[]> {
    if (storeSession.httpCx == undefined || etablissementId <= 0) {
      return Promise.resolve([]);
    }
    return storeSession.httpCx
      .get(`api/Salaries/idsByEtablissement/${etablissementId}`, getRequestConfig())
      .then(response => response.data as number[]);
  }

 
}
